import React from 'react';
import {
    Box,
    Button,
    Container,
    Grid,
    Typography,
    useTheme,
    useMediaQuery,
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import ConferenceNavbar from "../../../frontend/Conference/ConferenceNavbar";
import NewVersionAbstractFooter from "../../AbstractAuth/NewVersion/NewVersionAnstractFooter";
import { useDeadline } from "../../../contexts/DeadlineContext";

const ConferenceEvalutionThankYou = () => {
    const { abstractHomeSetup } = useDeadline();
    const location = useLocation();
    //const participantId = location.pathname.split("/").pop();
    const certificateUrl = location.state?.certificateUrl;
    const participantId = location.state?.participantId;
    
    const primaryColor = abstractHomeSetup.color_code_two || '#05597D';
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <Box display="flex" flexDirection="column" minHeight="100vh">
            <Grid item xs={12} sm={10} md={8} lg={6}>
                <ConferenceNavbar />
            </Grid>

            {/* Top-right Back Button */}
            <Box display="flex" justifyContent="flex-end" alignItems="center" p={2}>
                <Button
                    component={Link}
                    to="/conference/evaluation"
                    variant="contained"
                    size="small"
                    sx={{
                        backgroundColor: primaryColor,
                        '&:hover': {
                            backgroundColor: primaryColor,
                            opacity: 0.9,
                        },
                    }}
                >
                    Back to Verification
                </Button>
            </Box>

            {/* Main Content */}
            <Box flexGrow={1} display="flex" flexDirection="column" alignItems="center" justifyContent="center" px={2}>
                <Typography variant={isSmallScreen ? 'h5' : 'h4'} gutterBottom>
                    🎉 Thank You for Evaluation!
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    Your Evaluation has been successfully completed.
                </Typography>

                <Typography variant="body1" sx={{ mt: 1 }}>
                    <strong>QR Code ID:</strong> {participantId}
                </Typography>

                {certificateUrl && (
                    <Button
                        variant="outlined"
                        href={certificateUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            mt: 3,
                            color: primaryColor,
                            borderColor: primaryColor,
                            fontWeight: 'bold',
                            '&:hover': {
                                backgroundColor: primaryColor,
                                color: '#fff',
                                borderColor: '#fff',
                            },
                        }}
                    >
                        View Your Certificate
                    </Button>
                )}

                <Typography variant="body1"  mt={4} mb={4} textAlign="center">
                    📧 A confirmation email has been sent to your registered email address. If you don't see it in your inbox, please check your spam or junk folder.
                </Typography>
            </Box>

            {/* Footer */}
            <Grid item xs={12} sm={10} md={8} lg={6} sx={{ mt: 'auto' }}>
                <NewVersionAbstractFooter />
            </Grid>
        </Box>
    );
};




export default ConferenceEvalutionThankYou;
